import {numericIdFactory} from './numericIdFactory';
export const stringIdFactory = () => numericIdFactory().toString();
